import React from 'react';
import 'Lessons/angularModule';
import { angularDirectiveToReact } from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const ShowPracticePlayerDirective = angularDirectiveToReact('showPracticePlayer', {
    courseOrLesson: '<',
    contentItemId: '<',
});

export const ShowPracticePlayerComponent: React.FC = () => {
    const [key, params] = useAngularToReactRoute<{
        courseOrLesson: string;
        contentItemId: string;
    }>();

    return <ShowPracticePlayerDirective key={key} {...params} />;
};
